import { Stack } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { CrudFilters } from '@refinedev/core';
import { DeleteButton, EditButton, List, ShowButton, useDataGrid } from '@refinedev/mui';

import { Module } from '../../types';

const ModuleList = () => {
  const { dataGridProps, search } = useDataGrid<Module>({
    onSearch: search => {
      const filters: CrudFilters = [];

      filters.push({
        field: 'search',
        value: search,
        operator: 'eq'
      });

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'search',
          value: '',
          operator: 'eq'
        }
      ]
    }
  });

  const columns: GridColDef[] = [
    { field: 'display_name', headerName: 'Name', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: params => (
        <Stack direction="row" spacing={1}>
          <ShowButton recordItemId={params.row.id} hideText />
          <EditButton recordItemId={params.row.id} hideText />
          <DeleteButton
            recordItemId={params.row.id}
            hideText
            confirmTitle={'Do you want to delete Module: "' + params.row.display_name + '" ?'}
          />
        </Stack>
      ),
      sortable: false,
      flex: 1,
      maxWidth: 128
    }
  ];

  return (
    <List canCreate>
      <DataGridPro
        {...dataGridProps}
        filterModel={undefined}
        columns={columns}
        showToolbar
        onFilterModelChange={({ quickFilterValues }) => {
          search(quickFilterValues?.join(' ') || '');
        }}
        pagination
      />
    </List>
  );
};

export default ModuleList;
